const Regex = {
  number: /^-?\d+(\.\d)?$/,
  /** A new password must mix upper case, lower case and a digit. */
  strongPassword: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

export default Regex;
